import { DEFAULT_PAGINATION } from '@frontend/const'
import type { LocalStorageState } from 'use-local-storage-state'
import useLocalStorageState from 'use-local-storage-state'

export const TABLE_PAGE_SIZE_STORAGE_KEY_PREFIX = 'tablePageSize'

export const getTablePageSizeStorageKey = (tableKey: string): string =>
  `${TABLE_PAGE_SIZE_STORAGE_KEY_PREFIX}:${tableKey}`

export const useTablePageSize = (
  tableKey: string,
  defaultPageSize = DEFAULT_PAGINATION.pageSize
): LocalStorageState<number> =>
  useLocalStorageState(getTablePageSizeStorageKey(tableKey), {
    defaultValue: defaultPageSize,
  })
